import React from 'react'

import { SvgProps } from './types'

function CollapseSvg({
  width,
  height,
  className,
  stroke,
  fill,
  strokeColor,
  size,
  styles,
}: SvgProps) {
  const { innerWidth } = window
  const defaultWidth = innerWidth > 1024 ? 's' : 'm'
  const sizeKey = typeof size === 'undefined' ? defaultWidth : size

  const scale = {
    xl: 3.0,
    lg: 2.5,
    m: 1.0,
    s: 0.8,
    xs: 0.5,
  }

  return (
    <svg
      className={className}
      style={{
        ...styles,
        ...{
          height: 'auto',
          transform: `scale(${scale[sizeKey]})`,
        },
      }}
      xmlns="http://www.w3.org/2000/svg"
      width={width || '48'}
      height={height || '48'}
      viewBox="0 0 24 24"
      fill={fill || 'none'}
    >
      <path
        d="M4 20L9 15M9 15V19M9 15H5"
        stroke={strokeColor || 'currentColor'}
        strokeWidth={stroke || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 4L15 9M15 9V5M15 9H19"
        stroke={strokeColor || 'currentColor'}
        strokeWidth={stroke || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CollapseSvg
